import { render, staticRenderFns } from "./FlowfactCredentials.vue?vue&type=template&id=81cba21a&scoped=true&"
import script from "./FlowfactCredentials.vue?vue&type=script&lang=js&"
export * from "./FlowfactCredentials.vue?vue&type=script&lang=js&"
import style0 from "./FlowfactCredentials.vue?vue&type=style&index=0&id=81cba21a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81cba21a",
  null
  
)

export default component.exports